// declaration for month formatting
const months = [
    "January", "February", "March", "April", "May", "June",
    "July", "August", "September", "October", "November", "December"
];

// table sort logic
export const handleReportingIndexSort = () => {
    const table = document.getElementById("businessTable");
    const headers = document.querySelectorAll(".sortable");
    const defaultColumnIndex = 3;
    const defaultOrder = "desc";

    if (!table) return;

    sortTable(table, defaultColumnIndex, defaultOrder);
    // updateIcons(headers[defaultColumnIndex - 1], defaultOrder);

    headers.forEach(header => {
        header.addEventListener("click", function () {
            const columnIndex = this.dataset.column;
            let order = this.dataset.order;

            order = order === "asc" ? "desc" : "asc";
            this.dataset.order = order;

            updateIcons(this, order);
            headers.forEach(h => h.classList.remove("sorted-asc", "sorted-desc"));
            this.classList.add(order === "asc" ? "sorted-asc" : "sorted-desc");
            sortTable(table, columnIndex, order);
        });
    });

    function sortTable(table, column, order) {
        const tbody = table.querySelector("tbody");
        const rows = Array.from(tbody.querySelectorAll("tr"));

        rows.sort((rowA, rowB) => {
            let cellA = rowA.cells[column].textContent.trim();
            let cellB = rowB.cells[column].textContent.trim();

            cellA = parseFloat(cellA.replace('%', '')) || 0;
            cellB = parseFloat(cellB.replace('%', '')) || 0;

            return order === "asc" ? cellA - cellB : cellB - cellA;
        });

        tbody.innerHTML = "";
        rows.forEach(row => tbody.appendChild(row));
    }

    function updateIcons(header, order) {
        document.querySelectorAll(".sortable i").forEach(icon => {
            icon.classList.remove("fa-chevron-up", "fa-chevron-down");
            icon.classList.add("fa-chevron-down");
        });

        const icon = header.querySelector("i");
        if (order === "asc") {
            icon.classList.remove("fa-chevron-down");
            icon.classList.add("fa-chevron-up");
        } else {
            icon.classList.remove("fa-chevron-up");
            icon.classList.add("fa-chevron-down");
        }
    }
};

// Nav tabs
export const toggleNavTabs = () => {
    const tabs = document.querySelectorAll('.reporting-tabs li');
    const sections = document.querySelectorAll('.tab-section');
    const monthData = window.months_data;

    const initialDropdown = document.querySelector('select[data-context]');
    if (initialDropdown && !initialDropdown.dataset.populated) {
        renderMonthDropdown(monthData, initialDropdown.id);
        initialDropdown.dataset.populated = "true";
    }

    tabs.forEach(tab => {
        tab.addEventListener('click', () => {
            tabs.forEach(t => t.classList.remove('active'));
            sections.forEach(s => s.classList.remove('active'));

            tab.classList.add('active');
            const selected = tab.getAttribute('data-tab');
            const activeSection = document.getElementById('tab-' + selected);
            activeSection.classList.add('active');

            const dropdown = document.querySelector('select[data-context]');
            if (dropdown && !dropdown.dataset.populated) {
                renderMonthDropdown(monthData, dropdown.id);
                dropdown.dataset.populated = "true";
            }
        });
    });
};

// Grab corresponding data based on selected month/year
function renderDataForMonthYear(dateStr) {
    const [year, month] = dateStr.split("-");
    const formatted = `${monthName(month)} ${year}`;
    const data = window.months_data[formatted];

    updateMonthTitle(month, year);

    if (data) {
        populateTable(data);
        updateTableHeaders(data);
        updateMonthTitle(month, year);
    } else {
        clearTable();
    }
}

// Populate table with jurisdiction rows
function populateTable(data) {
    const tbody = document.querySelector("#businessTable tbody");
    if (!tbody) return;

    tbody.innerHTML = "";

    data.jurisdiction_data.forEach(jurisdiction => {
        const row = document.createElement("tr");

        row.innerHTML = `
            <td>${jurisdiction.state || ""}</td>
            <td>${jurisdiction.new_businesses || ""}</td>
            <td>${jurisdiction.new_businesses2 || ""}</td>
            <td>${jurisdiction["%_change"] ? jurisdiction["%_change"] + "%" : ""}</td>
            <td>${jurisdiction.new_businesses3 || ""}</td>
            <td>${jurisdiction["%_change2"] ? jurisdiction["%_change2"] + "%" : ""}</td>
            <td>${jurisdiction["12_month_avg"] || ""}</td>
        `;

        tbody.appendChild(row);
    });
}

function updateTableHeaders(data) {
    document.querySelector('[data-column="1"] span').textContent = data.new_businesses_col_label_1 || "";
    document.querySelector('[data-column="2"] span').textContent = data.new_businesses_col_label_2 || "";
    document.querySelector('[data-column="3"] span').textContent = data.change_col_label_1 || "";
    document.querySelector('[data-column="4"] span').textContent = data.new_businesses_col_label_3 || "";
    document.querySelector('[data-column="5"] span').textContent = data.change_col_label_2 || "";
    document.querySelector('[data-column="6"] span').textContent = data.rolling_avg_col_label || "";
}

// Format month string from picker (e.g., "2025-05" → "May2025")
function monthName(monthNum) {
    return months[parseInt(monthNum, 10) - 1];
}

// Table header
function updateMonthTitle(month, year) {
    const monthName = months[parseInt(month, 10) - 1];
    const titleEl = document.getElementById("selected-month-title");

    if (titleEl) {
        titleEl.textContent = `${monthName} ${year}`;
    }
}

// No data found for month
function clearMonthTitle() {
    const titleEl = document.getElementById("selected-month-title");
    if (titleEl) {
        titleEl.textContent = "";
    }
}

// Show message if no data found
function clearTable() {
    const tbody = document.querySelector("#businessTable tbody");
    if (tbody) {
        tbody.innerHTML = `<tr><td colspan="7" style="text-align:center; font-style: italic;">No data available for this month.</td></tr>`;
    }

    updateTableHeaders({
        new_businesses_label_1: "",
        new_businesses_label_2: "",
        change_label_1: "",
        new_businesses_label_3: "",
        change_label_2: "",
        rolling_avg_label: ""
    });
}

// Date picker logic
export const setupMonthYearDropdowns = () => {
    const monthSelect = document.getElementById('month-dropdown');
    const yearSelect = document.getElementById('year-dropdown');

    if (!monthSelect || !yearSelect) return;

    const wrapper = document.getElementById('data-table');
    const defaultMonth = wrapper?.dataset.defaultMonth || "";
    const defaultYear = wrapper?.dataset.defaultYear || "";

    if (defaultMonth && defaultYear) {
        monthSelect.value = defaultMonth;
        yearSelect.value = defaultYear;
    }

    function updateFromDropdowns() {
        const month = monthSelect.value;
        const year = yearSelect.value;
        const key = `${month} ${year}`;

        if (window.months_data[key]) {
            const monthIndex = months.indexOf(month) + 1;
            const paddedMonth = String(monthIndex).padStart(2, '0');
            const valueForBackwardsCompat = `${year}-${paddedMonth}`;

            updateMonthTitle(paddedMonth, year);
            renderDataForMonthYear(valueForBackwardsCompat);
        } else {
            clearTable();
            clearMonthTitle();
        }
    }

    updateFromDropdowns();

    monthSelect.addEventListener('change', updateFromDropdowns);
    yearSelect.addEventListener('change', updateFromDropdowns);
};

// render selected month/year (summary tab - redirect user to selected post)
function renderMonthDropdown(monthsData, dropdownId = 'summary-months') {
    const dropdown = document.getElementById(dropdownId);
    if (!dropdown || !monthsData) return;


    // Convert to array and sort by date descending
    const sortedMonths = Object.values(monthsData).sort((a, b) => {
        return new Date(b.month_year) - new Date(a.month_year);
    });


    // Add default option
    const defaultOption = document.createElement('option');
    defaultOption.textContent = 'Select Month';
    defaultOption.disabled = true;
    defaultOption.selected = true;
    dropdown.appendChild(defaultOption);

    // Append sorted options
    sortedMonths.forEach(post => {
        const option = document.createElement('option');
        option.value = post.url;
        option.textContent = post.label;
        dropdown.appendChild(option);
    });

    // Handle selection
    dropdown.addEventListener('change', function () {
        const selectedUrl = this.value;
        if (selectedUrl) window.location.href = selectedUrl;
    });
}
